import React, { useState, useEffect } from "react";
import { buildSrcSets } from "../utils/imageSrcSet";

export default function Banner() {
  const [isMounted, setIsMounted] = useState(false);
  
  // Prevent CLS by only rendering after mount
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Calculate aspect ratio (width / height) of the banner image
  // Intrinsic dimensions measured via `sips`: 1838 x 391
  const aspectRatio = 1838 / 391;
  const paddingTop = `${(1 / aspectRatio) * 100}%`;

  if (!isMounted) {
    // Return a placeholder with the same dimensions to prevent layout shift
    return (
      <div style={{
        width: '100%',
        paddingTop,
        position: 'relative',
        overflow: 'hidden',
        background: '#f0f0f0' // Optional: Add a background color
      }} />
    );
  }

  return (
    <div style={{
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        width: '100%',
        paddingTop,
        position: 'relative',
        overflow: 'hidden'
      }}>
        {(() => {
          const { srcSetWebp, srcSetJpg } = buildSrcSets("Corfe-Castle-from-Fig-Tree-cottage", [768, 1200, 1600, 1838]);
          const fallback = `${process.env.PUBLIC_URL || ''}/images/optimized/Corfe-Castle-from-Fig-Tree-cottage-w1838.jpg`;
          return (
            <picture>
              <source type="image/webp" srcSet={srcSetWebp} sizes="100vw" />
              <source type="image/jpeg" srcSet={srcSetJpg} sizes="100vw" />
              <img
                src={fallback}
                alt="Fig Tree Cottage Banner"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                  margin: 0,
                  padding: 0
                }}
                width={1838}
                height={391}
                loading="eager"
                fetchPriority="high"
                decoding="async"
              />
            </picture>
          );
        })()}
      </div>
    </div>
  );
}
